import { FC } from 'react';

import { Container as MuiContainer, useMediaQuery } from '@mui/material';

import Meta from '@/components/Meta';

import Header from './Header';
import Animation from './components/Animation/Animation';
import { useCurrentStep } from './hooks';
import CreateWorkspace from './steps/CreateWorkspace';
import ExistingWorkspace from './steps/ExistingWorkspace';
import ExistingWorkspaceSent from './steps/ExistingWorkspaceSent';
import Profile from './steps/Profile';
import { BottomAccent, Container, Left, Right, TopAccent, Wrapper } from './styled';
import { OnboardingProps, OnboardingStep } from './types';

const mapStepToComponent: Record<OnboardingStep, FC> = {
  [OnboardingStep.Profile]: Profile,
  [OnboardingStep.CreateWorkspace]: CreateWorkspace,
  [OnboardingStep.JoinExisting]: ExistingWorkspace,
  [OnboardingStep.RequestedToJoin]: ExistingWorkspaceSent,
};

function Onboarding({ providedStep }: OnboardingProps) {
  const step = useCurrentStep();
  const isSmallScreen = useMediaQuery('(max-width:900px)');

  const stepsMap = mapStepToComponent;
  const Component = stepsMap[providedStep || step];

  return (
    <Meta responsive>
      <Container>
        <MuiContainer maxWidth="lg" sx={{ height: '100%' }}>
          <Wrapper direction="row">
            <Left sx={{ width: isSmallScreen ? '100%' : '50%' }}>
              <Header />
              <Component />
              <BottomAccent side="left" />
            </Left>
            {!isSmallScreen && (
              <Right>
                <TopAccent />
                <Animation />
                <BottomAccent side="right" />
              </Right>
            )}
          </Wrapper>
        </MuiContainer>
      </Container>
    </Meta>
  );
}

export default Onboarding;
